import { render, staticRenderFns } from "./BcCombobox.vue?vue&type=template&id=2b6e179c"
import script from "./BcCombobox.vue?vue&type=script&lang=js"
export * from "./BcCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports